module.exports = __webpack_public_path__ + "img/jboard_512x512.723ff9f8.png";